export default {
   INDEX: "/",
   INTRO: "intro",
   JOINGAME: "join_game",
   NEWGAME: "new_game",
   MAINGAME: "main_game",
   ADMINVIEW: "admin",
   SUMMARY: "summary",
};
